import React from "react";
import "../../../../../Assets/Styles/LoadingIndicator.scss";
import ConnexingLoadingIndicatorBlue from "./ConnexingLoadingIndicatorBlue";
import ConnexingLoadingIndicatorWhite from "./ConnexingLoadingIndicatorWhite";

const LoadingIndicatorCircle = () => {
  return (
    <>
      {window.innerWidth <= 450 ? (
        <ConnexingLoadingIndicatorBlue />
      ) : (
        <ConnexingLoadingIndicatorWhite />
      )}
    </>
  );
};

export default LoadingIndicatorCircle;
